module.exports = __webpack_public_path__ + "img/question.380953e.svg";